import Creative from "../Creative";
import {handlersNames} from "../handlers";
import {extraKeys, genderKeys, typeKeys} from "../etc";
import {isWebviewApp} from "../../utils/config.utils";
import {webviewAppIds} from "../../utils/webview";
import {genders} from "./helpers";
import d22seeds from "./d22-seeds.json";

export const configBuilders = {
  simple8866: "simple8866",
  barbifyAiOld: "barbify_ai_old",
  simple8872: "simple8872",
  barbieAiBody: "barbie_ai_body"
};

export function getPrompts(gender) {
  return [
    // мужские
    {id: "wt_d19wc_barbie_male", genders: [genderKeys.male], builder: configBuilders.simple8872},
    {id: "wt_d19_barbie_male_7", genders: [genderKeys.male], builder: configBuilders.simple8866},
    {id: "wt_d19wc_barbie_male_style", genders: [genderKeys.male], builder: configBuilders.simple8872},
    {id: "wt_d19_barbie_male_6", genders: [genderKeys.male], builder: configBuilders.simple8866},
    {id: "wt_d19_barbie_male_2", genders: [genderKeys.male], builder: configBuilders.simple8866},
    {id: "wt_d19_barbie_male_5", genders: [genderKeys.male], builder: configBuilders.simple8866},
    {id: "wt_d19_barbie_male_8", genders: [genderKeys.male], builder: configBuilders.simple8866},

    // женские
    {id: "wt_d19_barbie_female_6", genders: [genderKeys.female], builder: configBuilders.simple8866},
    {id: "wt_d19_barbie_female_5", genders: [genderKeys.female], builder: configBuilders.simple8866},
    {id: "wt_d19_barbie_female_2", genders: [genderKeys.female], builder: configBuilders.simple8866},
    {id: "wt_d19_barbie_female_9", genders: [genderKeys.female], builder: configBuilders.simple8866},
    {id: "wt_d19_barbie_female_4", genders: [genderKeys.female], builder: configBuilders.simple8866},
    {id: "wt_d19wc_barbie_female_1", genders: [genderKeys.female], builder: configBuilders.simple8872},
    {id: "wt_d19wc_barbie_female_2", genders: [genderKeys.female], builder: configBuilders.simple8872},
  ].filter((item) => {
    return item.genders.indexOf(gender) >= 0;
  });
}

export function getBarbieAiBodyPrompts() {
  return [
    // мужские

    {id: "m_barbie_ai_body", templateId: "m_barbie_ai_body", genders: [genderKeys.male], builder: configBuilders.barbieAiBody, template_name: 8866},
    {id: "m_barbie_ai_body", templateId: "m_barbie_ai_body_tropical_beach", genders: [genderKeys.male], builder: configBuilders.barbieAiBody},
    {id: "m_barbie_ai_body", templateId: "m_barbie_ai_body_garage", genders: [genderKeys.male], builder: configBuilders.barbieAiBody},
    {id: "m_barbie_ai_body", templateId: "m_barbie_ai_body_park", genders: [genderKeys.male], builder: configBuilders.barbieAiBody},
    {id: "m_barbie_ai_body", templateId: "m_barbie_ai_body_kitchen", genders: [genderKeys.male], builder: configBuilders.barbieAiBody},
    {id: "m_barbie_ai_body", templateId: "m_barbie_ai_body_street_cars", genders: [genderKeys.male], builder: configBuilders.barbieAiBody},
    {id: "m_barbie_ai_body", templateId: "m_barbie_ai_body_theatre", genders: [genderKeys.male], builder: configBuilders.barbieAiBody},
    {id: "m_barbie_ai_body", templateId: "m_barbie_ai_body_grocery_shop", genders: [genderKeys.male], builder: configBuilders.barbieAiBody},
    {id: "m_barbie_ai_body", templateId: "m_barbie_ai_body_sailor", genders: [genderKeys.male], builder: configBuilders.barbieAiBody},
    {id: "m_barbie_ai_body", templateId: "m_barbie_ai_body_toy_house", genders: [genderKeys.male], builder: configBuilders.barbieAiBody},
    {id: "m_barbie_ai_body", templateId: "m_barbie_ai_body_winter_village", genders: [genderKeys.male], builder: configBuilders.barbieAiBody},
    {id: "m_barbie_ai_body", templateId: "m_barbie_ai_body_sheriff", genders: [genderKeys.male], builder: configBuilders.barbieAiBody},
    {id: "m_barbie_ai_body", templateId: "m_barbie_ai_body_kitchen_1", genders: [genderKeys.male], builder: configBuilders.barbieAiBody},

    // женские
    {id: "barbie_ai_body", templateId: "barbie_ai_body", genders: [genderKeys.female], builder: configBuilders.barbieAiBody, template_name: 8866},
    {id: "barbie_ai_body", templateId: "barbie_ai_body_waterfall_tourism", genders: [genderKeys.female], builder: configBuilders.barbieAiBody},
    {id: "barbie_ai_body", templateId: "barbie_ai_body_autumn_puppy", genders: [genderKeys.female], builder: configBuilders.barbieAiBody},
    {id: "barbie_ai_body", templateId: "barbie_ai_body_pool", genders: [genderKeys.female], builder: configBuilders.barbieAiBody},
    {id: "barbie_ai_body", templateId: "barbie_ai_body_restaurant", genders: [genderKeys.female], builder: configBuilders.barbieAiBody},
    {id: "barbie_ai_body", templateId: "barbie_ai_body_colorful_office", genders: [genderKeys.female], builder: configBuilders.barbieAiBody},
    {id: "barbie_ai_body", templateId: "barbie_ai_body_office", genders: [genderKeys.female], builder: configBuilders.barbieAiBody},
    {id: "barbie_ai_body", templateId: "barbie_ai_body_theatre", genders: [genderKeys.female], builder: configBuilders.barbieAiBody},
    {id: "barbie_ai_body", templateId: "barbie_ai_body_grocery_shop", genders: [genderKeys.female], builder: configBuilders.barbieAiBody},
    {id: "barbie_ai_body", templateId: "barbie_ai_body_sailor", genders: [genderKeys.female], builder: configBuilders.barbieAiBody},
    {id: "barbie_ai_body", templateId: "barbie_ai_body_toy_house", genders: [genderKeys.female], builder: configBuilders.barbieAiBody},
    {id: "barbie_ai_body", templateId: "barbie_ai_body_hospital", genders: [genderKeys.female], builder: configBuilders.barbieAiBody},
    {id: "barbie_ai_body", templateId: "barbie_ai_body_kitchen", genders: [genderKeys.female], builder: configBuilders.barbieAiBody},
    {id: "barbie_ai_body", templateId: "barbie_ai_body_bar", genders: [genderKeys.female], builder: configBuilders.barbieAiBody},
  ]
}

export function getVideoId() {
  let videoId = 8875;

  if (!window.clientConfig.isPro) {
    if (isWebviewApp(webviewAppIds.dollme) || window.clientConfig.isWeb) {
      videoId = 8897;
    } else if (isWebviewApp(webviewAppIds.photolabFree, webviewAppIds.photolabHuawei)) {
      videoId = 8877;
    } else if (isWebviewApp(webviewAppIds.toonme, webviewAppIds.toonmeHuawei)) {
      videoId = 8878;
    }
  }

  return videoId;
}

export function createCreativesByPromptConfig(processing, config, context) {
  const imageSteps = getSteps(config, {
    ...{gender: processing.getExtra(extraKeys.gender)},
    ...context,
  });

  const imageCreative = new Creative();
  imageCreative.setGroup(config.id);
  imageCreative.setTemplateId(config.templateId || imageSteps.map((step) => step.id).join("_"));
  imageCreative.setHandler(handlersNames.COMBO);
  imageCreative.setExtra(Creative.EXTRA_COMBO_STEPS, imageSteps);
  imageCreative.setExtra(Creative.EXTRA_KEEP_PENDING, true);
  imageCreative.setExtra(extraKeys.gender, context.gender || processing.getExtra(extraKeys.gender));
  imageCreative.setExtra(extraKeys.type, typeKeys.image);
  imageCreative.setAsSelected(true);

  const videoSteps = JSON.parse(JSON.stringify(imageSteps));
  delete videoSteps.last().setAsFile;
  videoSteps.push({id: getVideoId(), setAsFile: "raw"});

  const videoCreative = new Creative();
  videoCreative.setGroup(config.id);
  videoCreative.setTemplateId(videoSteps.map((step) => step.id).join("_"));
  videoCreative.setHandler(handlersNames.COMBO);
  videoCreative.setExtra(Creative.EXTRA_COMBO_STEPS, videoSteps);
  videoCreative.setExtra(Creative.EXTRA_KEEP_PENDING, true);
  videoCreative.setExtra(extraKeys.gender, context.gender || processing.getExtra(extraKeys.gender));
  videoCreative.setExtra(extraKeys.type, typeKeys.video);
  videoCreative.setExtra(extraKeys.withSound, true);
  videoCreative.setExtra(extraKeys.isPro, window.clientConfig.isPro);

  return [imageCreative, videoCreative];
}

export function createAiBodyCreativeByPromptConfig(processing, config, context) {
  const isFullsizeWatemark = !window.clientConfig.isPro;

  const creative = new Creative();
  creative.setGroup(config.id);
  creative.setTemplateId(config.templateId);
  creative.setHandler(handlersNames.D22);
  creative.setExtra(Creative.EXTRA_KEEP_PENDING, true);
  creative.setExtra(extraKeys.gender, context.gender || processing.getExtra(extraKeys.gender));
  creative.setExtra(extraKeys.type, typeKeys.image);
  creative.setExtra(extraKeys.seed, d22seeds.random());

  if (isFullsizeWatemark) {
    creative.setExtra(extraKeys.sdxlWatermarkTemplate, window.appConfig.isBarbifyMe ? 8922 : 8921);
    creative.setExtra(extraKeys.noWatermarkOnResult, true);
  }

  return creative;
}

function getSteps(config, context) {
  if (config.builder === configBuilders.simple8866 || config.builder === configBuilders.simple8872) {
    return getStepsForDefault(config, context);
  } else if (config.builder === configBuilders.barbifyAiOld) {
    return getStepsForBarbifyAiOld(config, context);
  } else {
    throw new Error("Unrecognized config builder: " + config.builder);
  }
}

function getStepsForDefault(config, context) {
  const templateGender = context.gender
    .replace("female", "woman")
    .replace("male", "man");

  return [
    {
      id: config.builder === configBuilders.simple8872 ? 8872 : 8866,
      images: [{src: "@", useAltBody: true}],
      templateParams: {
        "@configId": config.configId || config.id,
        gender: templateGender,
      },
      setAsFile: "raw",
    },
  ];
}

function getStepsForBarbifyAiOld(config, context) {
  const templateGender = context.gender
    .replace("female", "woman")
    .replace("male", "man");

  const faceSteps = [];
  const templateParams = {};

  if (context.gender === genders.male) {
    faceSteps.push({id: 7088});
    templateParams["@replacements"] = [{
      parameters: ["prompt"],
      search: "barbie",
      mode: "ig",
      replacement: "Ken",
    }];
  } else {
    faceSteps.push({id: 6472}, {id: 8666});
  }

  return [
    {
      id: 8205,
      images: [{src: "@", useAltBody: true}],
    },
    ...faceSteps,
    {
      id: 8681,
      templateParams: {
        ...templateParams,
        "@transformationId": "barbify_old",
        "@configId": config.configId || config.id,
        canvas_template_name: 8659,
        mask_template_name: 8660,
        param_ipfl: 1,
        param_gm: "TRUE",
        param_s: 0.4,
        gender: templateGender,
      },
      setAsFile: "raw",
    },
  ];
}